import { colors } from '../../styles';

export const generalInputStyles = `
width: 100%;
padding: 12px 16px;
color: ${colors.midnightBlack};
border: 1px solid ${colors.gray3};
font-size: 16px;
height: 48px;

::placeholder {
color: ${colors.gray2};
}

&:focus,
&:active {
outline: 0;
border: 1px solid ${colors.crederaRed};
}
`;

export const radioInputStyles = `
position: absolute;
opacity: 0;
width: 20px;
height: 20px;
top: 6px;
`;

export const checkboxInputStyles = `
background: transparent;
border: 1px solid #D2D2D2;
box-sizing: border-box;
border-radius: 3px;
height: 20px;
width: 20px;
`;
